<template>
  <div class="move-pending">
    <img src="/assets/images/icon_pending.svg" alt=""/>
    <h3>{{ $t('digitalServices.move.pendingStatus.title') }}</h3>
  </div>
</template>

<script>
export default {
  name: 'move-pending-status'
}
</script>

<style scoped lang="scss">
.move-pending {
  width: 100%;
  padding: 4rem 2rem;
  text-align: center;

  img {
    width: 80px;
    height: auto;
    margin-bottom: 2.4rem;
  }

  h3 {
    font-weight: normal;
    font-size: 3.2rem;
    //margin-bottom: 2.4rem;
    margin-bottom: 1.8rem;
  }

  p {
    font-size: 1.6rem;
    margin-bottom: 1.8rem;
  }
}
</style>
